import { render, staticRenderFns } from "./TaskAssignmentCompleteTask.vue?vue&type=template&id=254da3f4"
import script from "./TaskAssignmentCompleteTask.vue?vue&type=script&lang=js"
export * from "./TaskAssignmentCompleteTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports